
import { TellAFriendCSSStyleImpl } from './tellafriendcss';
import { UIComponentImpl, UIComponentState, UIComponentHandler, UIComponentProps } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { TellAFriendViewImpl } from './tellafriendview';
import { ToneDto } from '../../../../core/dto/tonedto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { TellAFriendAPIModelImpl, TellAFriendAPIModel } from './tellafriendapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { ReferToneDto } from '../../../../core/dto/refertone/refertonedto';
import { ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface TellAFriendComponentProps extends UIComponentProps
{
    toneOptionsType: ToneOptionsType;
    toneDto: ToneDto;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;

   
}


export interface TellAFriendComponentHandler extends UIComponentHandler
{
    onConfirmClick(): void;
}

export class TellAFriendComponent extends UIComponentImpl<TellAFriendComponentProps, UIComponentState, ReferToneDto> 
implements TellAFriendComponentHandler
{
    constructor(props: TellAFriendComponentProps)
    {
        super(props);
    }
   
    componentWillUnmount()
    {
        document.removeEventListener("keydown",()=>'');
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<ReferToneDto>
    {
        return new TellAFriendViewImpl(applicationContext, uiComponentHandler);
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        
        // (this.getAPIModel() as TellAFriendAPIModel).getTonePrice(this.props.toneDto);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TellAFriendCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new TellAFriendAPIModelImpl(applicationContext, apiModelHandler);
    }

    onConfirmClick(): void 
    {
        if(this.getView().validate())
        {
            (this.getView() as TellAFriendViewImpl).showLoader(); 
            (this.getAPIModel() as TellAFriendAPIModel).getTonePrice((this.getView() as TellAFriendViewImpl).getData());
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as TellAFriendViewImpl).dismissLoader(); 
        if(feature === APIFeatures.REFER_TONE)
        {
               this.props.showPopup(this.props.context.getResources().getString(Strings.tellafriend),
               this.getContext().getResources().getString(Strings.tellafriend_successmsg),AlertType.SUCCESS);
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {       
        (this.getView() as TellAFriendViewImpl).dismissLoader(); 
        if(feature === APIFeatures.REFER_TONE)
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.tellafriend),
            this.props.context.getResources().getString(Strings.tellafriend_failuremsg),AlertType.ERROR);
        }
        else
        {
            this.props.showPopup(this.props.context.getResources().getString(Strings.tellafriend), description,AlertType.ERROR);

        }    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tellafriend/tellafriendcomponent.tsx